import { render, staticRenderFns } from "./serviveInfo.vue?vue&type=template&id=0ad3a5cd&scoped=true"
import script from "./serviveInfo.vue?vue&type=script&lang=js"
export * from "./serviveInfo.vue?vue&type=script&lang=js"
import style0 from "./serviveInfo.vue?vue&type=style&index=0&id=0ad3a5cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad3a5cd",
  null
  
)

export default component.exports